import React from "react";
import { Flex } from "antd";
import { EnterOutlined } from "@ant-design/icons";
import DataTable from "../Common/DataTable";

export default function ItemsTable(props) {
  const {
    plates,
    selectedPlateIndex,
    tableRef,
    tableHeightOffset,
    expandedRowKeys,
    setExpandedRowKeys,
    gridRef,
  } = props;

  const COLUMNS = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Unit Price",
      dataIndex: "unit_price",
      key: "unit_price",
      render: (t, r, i) => "RM " + t.toFixed(2),
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      key: "quantity",
      width: 40,
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (t, r, i) =>
        "RM " + ((r.unit_price ?? 0) * (r.quantity ?? 0)).toFixed(2),
    },
  ];

  const toggleExpandRow = (key) => {
    setExpandedRowKeys((prevExpandedRowKeys) => {
      if (prevExpandedRowKeys.includes(key)) {
        return [];
      } else {
        return [key];
      }
    });
  };

  return (
    <DataTable
      table_column={COLUMNS}
      table_data={plates[selectedPlateIndex]?.items ?? []}
      layoutRef={tableRef}
      size={"small"}
      tableWrapperViewportHeight={1}
      tableHeightOffset={tableHeightOffset}
      show_size_changer={false}
      default_page_size={100}
      pagination_position={["none", "none"]}
      scroll_x={null}
      expandable={{
        expandedRowRender: (record) => (
          <Flex className="expanded-row" justify="space-between" align="center">
            <p style={{ margin: 0, marginLeft: 10 }}>
              <EnterOutlined style={{ marginRight: 20, transform: "scaleX(-1)", fontSize: 17, color: "grey" }} />
              {record.sub_category}
            </p>
          </Flex>
        ),
        expandedRowKeys: expandedRowKeys,
        expandIcon: () => null,
        expandIconColumnIndex: -1,
      }}
      on_row={(record) => ({
        onClick: () => {
          toggleExpandRow(record.key);
        },
        onMouseEnter: (e) => e.stopPropagation(),
        onMouseLeave: (e) => e.stopPropagation(),
      })}
      row_bold={true}
      filterRef={gridRef}
      two_tone={true}
    />
  );
}
